import type { FC, ReactNode } from "react";

import { LoginModalView, useActiveLoginModalContext } from "@/src/contexts";
import ForgetPassword from "@/src/modals/forget-password";
import LoginRegistrationWrapper from "@/src/modals/login-registration/LoginRegistrationWrapper";
import type { ConsentScreenType, ConsentsResponse } from "@/src/modals/useConsents";
import LanguageSwitcher from "@/src/shared/language-switcher/language-switcher";
import * as stylexjs from "@stylexjs/stylex";

export interface ILoginRegistration {
    consentList: ConsentsResponse;
    loadedConsentType: ConsentScreenType;
}

export const LoginRegistration: FC<ILoginRegistration> = () => {
    let modal: ReactNode;
    const { activeLoginModal, setActiveLoginModal } = useActiveLoginModalContext();
    switch (activeLoginModal) {
        case LoginModalView.Login:
        case LoginModalView.Registration: {
            modal = <LoginRegistrationWrapper onSuccess={() => {}} />;

            break;
        }

        case LoginModalView.ForgetPassword: {
            const openLoginModal = () => setActiveLoginModal(LoginModalView.Login);
            modal = <ForgetPassword onBackButton={openLoginModal} />;
            break;
        }
        default:
            modal = null;
            break;
    }

    return (
        <div {...stylexjs.props(styles.container)}>
            <LanguageSwitcher styleX={styles.languageSwitcher} />
            {modal}
        </div>
    );
};

const styles = stylexjs.create({
    container: {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",

        maxWidth: "100vw",
        minHeight: "100vh",
    },

    languageSwitcher: {
        position: "absolute",
        right: 0,
        top: 0,
    },
});
